import { render, staticRenderFns } from "./CommunitiesUpdate.vue?vue&type=template&id=1594c86f"
import script from "./CommunitiesUpdate.vue?vue&type=script&lang=js"
export * from "./CommunitiesUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports